import { createContext, useContext, useState } from "react";


const SessionContext = createContext(null);

const useSession = () => {
  const { documents, setDocuments, activeDocument, setActiveDocument, contextId, setContextId, language, setLanguage, categoryOption, setCategoryOption} = useContext(SessionContext);

  const addDocument = (documentToAdd) => {
    if (documents.indexOf(documentToAdd) === -1) {
      setDocuments(currentDocuments => [...currentDocuments, documentToAdd]);
    }    
  };

  const removeDocument = (documentToDelete) => {
    setDocuments(currentDocuments => currentDocuments.filter(currentDoc => currentDoc !== documentToDelete));
  };

  const updateContextId = (newContextId) => {
    setContextId(newContextId);
  };

  const updateLanguage = (newLanguage) => {
    setLanguage(newLanguage);
  };

  const updateCategoryOption = (newCategoryOption) => {
    setCategoryOption(newCategoryOption);
  }

  const resetSession = () => {
    setDocuments([]);
    setActiveDocument({});
    setContextId(null);
    setLanguage(null);
    setCategoryOption(null);
  };

  return {
    documents,
    addDocument,
    removeDocument,
    activeDocument,
    setActiveDocument,
    resetSession,
    contextId,
    updateContextId,
    language,
    updateLanguage,
    categoryOption,
    updateCategoryOption
  };
};

const SessionProvider = ({ children }) => {
  const [documents, setDocuments] = useState([]);
  const [activeDocument, setActiveDocument] = useState({});
  const [contextId, setContextId] = useState(null);
  const [language, setLanguage] = useState(null);
  const [categoryOption, setCategoryOption] = useState(null);

  return (
    <SessionContext.Provider value={{documents, setDocuments, activeDocument, setActiveDocument, contextId, setContextId, language, setLanguage, categoryOption, setCategoryOption}}>
      {children}
    </SessionContext.Provider>
  )
};

export { SessionProvider, useSession };
